/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { SET_NO_ORGANIZATION, GET_ALL_ORGANIZATIONS, GET_ORGANIZATIONS_LIST, SET_SELECTED_ORGANIZATION, SET_PAGINATION_ORG } from "./types";

const initialState = {
  organizations: [],
  selectedOrganization: {},
  noOrganization: false,
  pagination: {
    pageNumber: 1,
    pageSize: 50,
    totalCount: 50,
  }
};

export const organizationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_ORGANIZATIONS:
      return {
        ...state,
        organizations: action.organizations,
        selectedOrganization: action.selectedOrganization,
        noOrganization: action.noOrganization,
      };
    case GET_ORGANIZATIONS_LIST:
      return {
        ...state,
        organizations: action.organizations,
      };
    case SET_SELECTED_ORGANIZATION:
      return {
        ...state,
        selectedOrganization: action.selectedOrganization,
      };
    case SET_NO_ORGANIZATION:
      return {
        ...state,
        noOrganization: action.noOrganization,
      };
    case SET_PAGINATION_ORG:
      return {
        ...state,
        pagination: action.pagination,
      };
    default:
      return state;
  }
};
